import erc20 from "./erc20.json"
import erc1155 from './erc1155.json'
import farmabi from './farmabi.json'
import shopabi from './shopabi.json'
import marketbi from './marketabi.json'
import multicallabi from './multicall.json'
import jaioyiduiabi from './jaioyidui.json'
export default {
    data() {
        return {
            global: {
                web3: undefined,
                account: undefined,
                BNBbalanceOf: 0,
                balanceOf: 0,
            },
            url: "https://api.studio.thegraph.com/query/748/omt-bsc/v0.0.1",
            onion: {
                erc1155: [ //erc1155 质押代币 购买盲盒用
                    "0xB5B7CA4DfE3237F8F06E1C66CBF535c14A56c273", //系列1
                    "0x7Efb96f7669B35B99B1A7F2dd49F8f5BC98062Ad", //系列2
                    "0x6B466b5E2c139678BaA5B32099d87F6d986aad99", //系列3
                ],
                Omt: "0x6071826ba85d2Bb94E655000270C6e685cbb6914", //挖出的代币
                dtc: "0xfe0b09f3d250e461992509f8e70e73a1bd288f86",
                USDT: "0x2a4040550894Bb74f20dEf7F2Be8bFE5C385FB73",
                jiaoyidui: "0xb5fFe6f27979CBC996D4b5c02b98c8d185627048",
                Farm: "0x58C45604d054c6729F4Ab73435788Ac08417adc8", //农场
                Shop: "0x928d476dCE0AB58E230f5Fe555A2F478a4b79649", //盲盒
                Market: "0x7B21c6b67ea45ea7E73eDEA080597a34416bE232", //市场
                omtfee:"0x8fDEFC3d9cf712c65B518b881C9BAFb8176F97DD", //omt回购
                slotfee:"0xaf1954ec8f343ff6986F4e9338280f23ADD3D481",//卡槽回购
                multicall: '0xDC9Cf2346fA9709B71a50cc992b3F36f9096878b'
                
            },
            onionabi: {
                ERC1155_abi: erc1155,
                Omt_abi: erc20,
                Farm_abi: farmabi,
                Market_abi: marketbi,
                Shop_abi: shopabi,
                multicall_abi: multicallabi,
                jiaoyidui_abi: jaioyiduiabi
            },
            contract: {
                ERC1155_contract: undefined,
                Omt_contract: undefined,
                Farm_contract: undefined,
                Shop_contract: undefined,
                Market_contract: undefined,
                USDT_contract: undefined,
                multicall: undefined,
                jiaoyidui_contract: undefined,
            },
            alldata: [{
                    "name": "Worker",
                    "cnname": "上班系列",
                    "price": "500000",
                    "slotPrice": "40",
                    "num": 1,
                    "tokens": [{
                            "tokenId": 1,
                            "duration": 3600,
                            "outRate": "0.10931069958847738"
                        },
                        {
                            "tokenId": 2,
                            "duration": 3600,
                            "outRate": "0.10931069958847738"
                        },
                        {
                            "tokenId": 3,
                            "duration": 3600,
                            "outRate": "0.10931069958847738"
                        },
                        {
                            "tokenId": 4,
                            "duration": 3600,
                            "outRate": "0.10931069958847738"
                        }
                    ]
                },
                {
                    "name": "Entrepreneur",
                    "cnname": "创业系列",
                    "price": "1000000",
                    "slotPrice": "40",
                    "num": 1,
                    "tokens": [{
                            "tokenId": 1,
                            "duration": 3600,
                            "outRate": "0.21862139917695475"
                        },
                        {
                            "tokenId": 2,
                            "duration": 3600,
                            "outRate": "0.21862139917695475"
                        },
                        {
                            "tokenId": 3,
                            "duration": 3600,
                            "outRate": "0.21862139917695475"
                        },
                        {
                            "tokenId": 4,
                            "duration": 3600,
                            "outRate": "0.21862139917695475"
                        }
                    ]
                },
                {
                    "name": "Rich",
                    "cnname": "财务自由",
                    "price": "1500000",
                    "slotPrice": "40",
                    "num": 1,
                    "tokens": [{
                            "tokenId": 1,
                            "duration": 3600,
                            "outRate": "0.3279320987654321"
                        },
                        {
                            "tokenId": 2,
                            "duration": 3600,
                            "outRate": "0.3279320987654321"
                        },
                        {
                            "tokenId": 3,
                            "duration": 3600,
                            "outRate": "0.3279320987654321"
                        },
                        {
                            "tokenId": 4,
                            "duration": 3600,
                            "outRate": "0.3279320987654321"
                        }
                    ]
                }
            ]
        }
    },
    created() {
        this.start();
        this.connectMetaMask()
        let self = this
        setTimeout(function chechAuth() {
            if (window.ethereum.selectedAddress === null) setTimeout(chechAuth, 200);
            else self.global.account = window.ethereum.selectedAddress
        }, 200);
    },
    methods: {
        start() {
            this.global.web3 = window.web3 = new this.Web3(window.ethereum);
            window.ethereum.autoRefreshOnNetworkChange = false;
            window.ethereum.on("accountsChanged", (item) => {
                console.log('accountsChanged', item[0])
            });
            window.ethereum.on("networkChanged", () => {
                console.log('networkChanged')
            });
        },
        async connectMetaMask() {
            // if (window.ethereum.selectedAddress) {
            //     this.global.account = window.ethereum.selectedAddress
            // } else {
            window.ethereum
                .request({
                    method: 'eth_requestAccounts'
                })
                .then((res) => {
                    // console.log(res);
                    this.global.account = res[0]
                })
                .catch((err) => {
                    if (err.code === 4001) {
                        // EIP-1193 userRejectedRequest error
                        // If this happens, the user rejected the connection request.
                        console.log('Please connect to MetaMask.');
                    } else {
                        console.error(err);
                    }
                });
            // }
            // try {
            //     const newAccounts = await window.ethereum.request({
            //         method: "eth_requestAccounts",
            //     });
            //     this.global.account = newAccounts[0]
            //     // handleNeewAccounts(newAccounts);
            // } catch (error) {
            //     // this.$message.warning("权限请求已待处理");
            // }
        },
        Balanceof() {
            new this.global.web3.eth.getBalance(this.global.account).then(res => {
                this.global.BNBbalanceOf = res
            })
            this.contract.Omt_contract = new this.global.web3.eth.Contract(
                this.onionabi.Omt_abi,
                this.onion.Omt
            );
            console.log(this.contract.Omt_contract);
            this.contract.Omt_contract.methods.balanceOf(this.global.account).call().then(res => {
                this.global.balanceOf = res
            })
        }
    },
}